export default "__VITE_ASSET__BSziG_9V__"